import { HistoricoVeiculoModel } from './model/historico-veiculo.model';
import { ResponseBase } from './../../../interfaces/response-base';
import { of } from 'rxjs';
import { IsLoadingService } from './../../../services/is-loading.service';
import { VeiculosService } from 'app/services/veiculos.service';
import { Component, OnInit } from '@angular/core';
import { TipoOperacaoEnum } from '../../../models/historico/tipo-operacao.enum';

@Component({
  selector: 'app-historico',
  templateUrl: './historico.component.html',
  styleUrls: ['./historico.component.scss']
})
export class HistoricoComponent {
  public placa: string;
  public veiculos: Array<HistoricoVeiculoModel>;
  TipoOperacao = TipoOperacaoEnum;
  public panelOpenState: true;
  public notFound = false;

  constructor(private veiculosService: VeiculosService, private loadingService: IsLoadingService) { }

  public getColor(tipo: TipoOperacaoEnum): any {
    let color: string;

    switch (tipo) {
      case TipoOperacaoEnum.INC:
        color = '#26BFA0';
        break;

      case TipoOperacaoEnum.ALT:
        color = '#158DE2';
        break;

      case TipoOperacaoEnum.EXC:
        color = '#CE1010';
        break;

      default:
        color = '#333';
    }
    return { color: color, fontWeight: 500 };
  }

  public buscarPlaca(placa: string): void {
    this.loadingService.isLoading = of(true);

    this.veiculosService.buscarHistorico(placa.replace('-', ''))
      .then((response: ResponseBase<Array<HistoricoVeiculoModel>>) => {
        this.notFound = response.data.length > 0 ? false : true;
        this.veiculos = response.data;
      });
  }

}
